import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IGetStatusDateChangedInterventionResponse from 'services/httpClient/responses/intervention/IGetStatusDateChangedInterventionResponse';

import { interventionActions } from '../index';
import { IGetStatusDateChangedInterventionRequestAction } from '../reducers/getStatusDateChanged/request';

function* getStatusDateChanged(
  action: PayloadAction<IGetStatusDateChangedInterventionRequestAction>,
) {
  try {
    const response: AxiosResponse<IGetStatusDateChangedInterventionResponse[]> =
      yield call(
        rikHttpClient.get,
        `intervention_status_logs/${action.payload.data.id}`,
      );

    yield put(
      interventionActions.getStatusDateChangedSuccess({
        interventionStatus: response.data,
      }),
    );
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(interventionActions.getStatusDateChangedFailure());
  }
}

export default getStatusDateChanged;
